import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { HintContentDescription } from './hint-content-description';
export const HintContentLink = forwardRef(({ ...props }, ref) => (_jsx(HintContentDescription, { as: "a", css: {
        textDecoration: 'underline',
        cursor: 'pointer',
    }, ...props, ref: ref })));
HintContentLink.displayName = 'HintContentLink';
